var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button jsmb-love",on:{"click":_vm.switchHeart}},[_c('i',{staticClass:"fa-heart",class:_vm.changeStateFav ? 'fas' : 'far'})])}
var staticRenderFns = []

export { render, staticRenderFns }